/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/variable/{variableId}/variable-address': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint32',
      },
    },
  },

  '/variable/{variableId}/modbus-variable-address': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: true,
      schema: {
        $ref: './definitions.yaml#/ModbusVariableAddress',
      },
    },
  },

  '/variable/{variableId}/type': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: true,
      schema: {
        $ref: './definitions.yaml#/VariableType',
      },
    },
  },

  '/variable/{variableId}/raw-meta': {
    put: {
      minApiVersion: 1.73,
      configModeRequired: true,
      schema: {
        $ref: './definitions.yaml#/Bytes',
      },
    },
  },

  '/variable/{variableId}/meta': {
    put: {
      minApiVersion: 1.73,
      configModeRequired: true,
      schema: {
        $ref: './definitions.yaml#/VariableMeta',
      },
    },
  },

  '/variable/{variableId}/unit': {
    put: {
      minApiVersion: 1.6,
      configModeRequired: true,
      schema: {
        type: 'string',
      },
    },
  },

  '/variable/{variableId}/number-of-elements': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint8',
      },
    },
  },

  '/variable/{variableId}/value': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: true,
      schema: {
        $ref: './definitions.yaml#/Bytes',
      },
    },
  },

  '/variable/{variableId}/bundle/id': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },
};
